import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiUrl from "../../../Environment/Api";

function TaskManagement() {
  const navigate = useNavigate();

  const UserRole = localStorage.getItem("role");
  const UserId = localStorage.getItem("editor_id");

  // States
  const [taskData, setTaskData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Delete Modal States
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTaskId, setDeleteTaskId] = useState(null);
  const [deleteEditorName, setDeleteEditorName] = useState("");
  const [deleteEditorId, setDeleteEditorId] = useState("");
  const [deleteTaskDate, setDeleteTaskDate] = useState("");

  const [clientData, setClientData] = useState([]);

  const fetchClientData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/clientdetails`);
      console.log("client data", response.data);
      setClientData(response.data || []);
    } catch (error) {
      console.log(error.message);
    }
  };

  // Fetch Task Data
  const fetchTaskData = async () => {
    try {
      const response = await axios.get(`${apiUrl}/taskmanagement`);

      let data = response.data || [];

      // Filter only for editor
      if (UserRole === "editor") {
        data = data.filter((task) => task.editor_id === UserId);
      }

      // Sort by latest (recent first)
      data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      setTaskData(data);
      setFilteredData(data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  useEffect(() => {
    fetchTaskData();
    fetchClientData();
  }, []);

  // Handle Search
  const handlesearchFilter = (e) => {
    const inputValue = e.target.value.trim().toLowerCase();
    const filtered = taskData.filter((task) =>
      Object.values(task).some((value) =>
        value?.toString().toLowerCase().includes(inputValue),
      ),
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // Delete Popup Handler
  const handleDeletePopup = (task) => {
    setDeleteTaskId(task.id);
    setDeleteEditorName(task.editor_name || "Unknown Editor");
    setDeleteEditorId(task.editor_id || "xxxx");
    setDeleteTaskDate(task.date || "");
    setShowDeleteModal(true);
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setDeleteTaskId(null);
  };

  // Delete Function
  const handleDelete = async () => {
    if (!deleteTaskId) return;

    try {
      const response = await axios.delete(
        `${apiUrl}/taskmanagement/${deleteTaskId}`,
      );

      if (response.status === 200 || response.status === 204) {
        toast.success("Task deleted successfully!", {
          autoClose: 3000,
          hideProgressBar: true,
        });

        // Refresh data
        fetchTaskData();
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete task. Please try again.");
    } finally {
      handleDeleteClose();
    }
  };

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    // .slice()
    // .reverse()
    .slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(filteredData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setItemsPerPage(Number(e.target.value));
  };

  // Format Date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  };

  const handleAddTask = () => {
    navigate("/add-taskmanagement");
  };

  return (
    <>
      <ToastContainer />

      <div className="d-flex">
        <h5 className="mt-2">Task Management</h5>
        <button
          className="btn btn-success mx-3 addbutton-heading"
          onClick={handleAddTask}
        >
          ADD
        </button>
      </div>
      <hr />

      {/* Search and Items per page */}
      <div className="d-flex justify-content-between">
        <div className="mx-2">
          <label>Show per page:</label>
          <select
            className="form-control"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={500}>500</option>
          </select>
        </div>
        <form>
          <label>Search :</label>
          <input
            className="form-control"
            type="text"
            placeholder="Search tasks..."
            onChange={handlesearchFilter}
          />
        </form>
      </div>

      <div className="invoicebackground mt-3">
        <div className="table-responsive table-responsive-data2">
          <table className="table table-striped">
            <thead>
              <tr className="tr-heading">
                <th>S.No</th>
                {/* <th>Date</th> */}
                <th>Editor Id / Name</th>
                <th>Client Id / Name</th>
                <th>Create Date</th>
                <th>Update Date</th>
                <th>No.Of Client</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length === 0 ? (
                <tr>
                  <td
                    colSpan="8"
                    style={{ textAlign: "center", padding: "30px" }}
                  >
                    No Tasks Available
                  </td>
                </tr>
              ) : (
                currentItems.map((task, index) => (
                  <tr key={task.id} className="tr-shadow">
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    {/* <td>{formatDate(task.date)}</td> */}
                    <td>
                      {task.editor_id} - {task.editor_name}
                    </td>
                    <td>
                      {task.client_details[0]?.client_id} -{" "}
                      {UserRole === "editor"
                        ? clientData.find(
                            (c) =>
                              c.client_id === task.client_details[0]?.client_id,
                          )?.alternat_name || "No Name"
                        : task.client_details[0]?.client_name}
                    </td>
                    <td>{formatDate(task.created_at)}</td>
                    <td>{formatDate(task.updated_at)}</td>
                    <td>{task.client_details?.length || 0}</td>
                    <td>
                      <button
                        className="btn btn-button mx-2 px-2 editbutton"
                        title="Edit"
                        onClick={() =>
                          navigate(`/update-taskmanagement/${task.id}`)
                        }
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </button>

                      {UserRole !== "editor" && (
                        <button
                          className="btn btn-button px-2 mx-2 deletebutton"
                          title="Delete"
                          onClick={() => handleDeletePopup(task)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div>
            <nav className="d-flex justify-content-end align-items-center mx-2 pt-3">
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button className="page-link mx-3" onClick={handlePrevPage}>
                    Previous
                  </button>
                </li>

                {Array.from(
                  { length: Math.ceil(filteredData.length / itemsPerPage) },
                  (_, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ),
                )}

                <li
                  className={`page-item ${
                    currentPage ===
                    Math.ceil(filteredData.length / itemsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <button className="page-link mx-3" onClick={handleNextPage}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal - Same style as Invoice */}
      <Modal show={showDeleteModal} onHide={handleDeleteClose}>
        <Modal.Header>
          <Modal.Title>
            <div className="row">
              <div className="col-lg-2 d-flex justify-content-center pt-2">
                <img
                  className="trash"
                  src={require("../../../../assets/img/Admin/bin.png")}
                  alt="delete"
                />
              </div>
              <div className="col-lg-10">
                <p className="popup-delete-text mt-2">
                  Are you sure you want to delete ?
                </p>
                <h6>Editor Name : {deleteEditorName}</h6>
                <h6>Editor ID : {deleteEditorId}</h6>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TaskManagement;
